import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, reactive, ref } from 'vue';
import { set } from '@vueuse/core';

import BasicButton from '@/ui-components/BasicButton.vue';
import StreamGreenSection from './StreamGreenSection.vue';
import RangeInput from '@/ui-components/RangeInput.vue';

import { useI18n } from '@/helpers/composables/useI18n';
import { WebLocale } from '@/enums/web-locale';
import type { FootprintParams } from './types';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreamGreenSurvey',
  emits: ["next"],
  setup(__props, { emit }: { emit: ({
	(event: 'next', params: FootprintParams): void;
}), expose: any, slots: any, attrs: any }) {



const { tc } = useI18n();
const { webLocale } = storeToRefs(useLanguageStore());

const windowWidth = ref(0);
const rangeDays = ref<HTMLElement | null>(null);
const rangeTitles = ref<HTMLElement | null>(null);
const selected = reactive({
	providers: {} as Record<string, boolean>,
	days: 3,
	titles: 2,
});

let styleTimeoutId: ReturnType<typeof setTimeout> | null = null;

onMounted(() => {
	styleTimeoutId = setTimeout(() => {
		const style = `
      transform: translate3d(0,-24px,0) scale(1);
      font-weight: bold;
      font-size: 18px;
      line-height: 15px;
    `;
		[rangeDays, rangeTitles].forEach(el => {
			const shadowRoot = el.value?.shadowRoot as ShadowRoot;
			shadowRoot?.querySelectorAll('.range-pin')?.forEach(pin => {
				pin.setAttribute('style', style);
			});
		});
	}, 500);

	const updateWindowWidth = () => {
		windowWidth.value = window.innerWidth;
	};
	updateWindowWidth();

	window.addEventListener('resize', updateWindowWidth);
	onBeforeUnmount(() => {
		if (styleTimeoutId) {
			clearTimeout(styleTimeoutId);
			styleTimeoutId = null;
		}
		window.removeEventListener('resize', updateWindowWidth);
	});
});

const ASSETS_DIR_PATH = computed(() => `/${ASSETS_DIR}`);

const questions = computed(() => [
	{ text: tc('WEBAPP_STREAMGREEN_SURVEY_STEP_1'), key: 'providers' },
	{ text: tc('WEBAPP_STREAMGREEN_SURVEY_STEP_2'), key: 'days' },
	{ text: tc('WEBAPP_STREAMGREEN_SURVEY_STEP_3'), key: 'titles' },
]);

const providers = computed<string[]>(() => {
	const map: Partial<Record<WebLocale, string[]>> = {
		[WebLocale.de]: ['netflix', 'amazonprime', 'joyn', 'skyticket', 'disneyplus', 'zdf', 'arte', 'ard', 'tvnow'],
		[WebLocale.us]: ['netflix', 'amazonprime', 'hulu', 'hbo', 'hbomax'],
	};

	return map[webLocale.value as WebLocale] ?? [];
});

const selectedProvidersAmount = computed(() => Object.values(selected.providers).filter(Boolean).length);

const buttonSize = computed(() => (process.client && windowWidth.value > 992 ? 'large' : 'default'));

function calculateResult() {
	const titlesByDays = selected.titles * selected.days;
	const moviesKwh = titlesByDays * (95 / 60) * 0.363;
	const showsKwh = titlesByDays * (45 / 60) * 0.637;
	const yearlyKwh = (moviesKwh + showsKwh) * 0.74 * 52 * 463;

	const params: FootprintParams = {
		selectedProviders: providers.value.filter(provider => selected.providers[provider]),
		yearlyKwh,
	};

	emit('next', params);
}

function toggleProvider(providerTechnicalName: string) {
	set(selected.providers, providerTechnicalName, !selected.providers[providerTechnicalName]);
}

return { __sfc: true,emit, tc, webLocale, windowWidth, rangeDays, rangeTitles, selected, styleTimeoutId, ASSETS_DIR_PATH, questions, providers, selectedProvidersAmount, buttonSize, calculateResult, toggleProvider, BasicButton, StreamGreenSection, RangeInput }
}

})